<ng-container *ngIf="keywordStore?.keywords?.length < 1; else showTable">
  <img *ngIf="emptyStateImageURL !== ''" class="empty-state" [src]="emptyStateImageURL" />
</ng-container>

<ng-template #showTable>
  <div
    *ngIf="(loading$ | async) === false; else loadingTable"
    class="scroll"
    matSort
    [matSortActive]="sortSettings.active"
    [matSortDirection]="sortSettings.direction"
    (matSortChange)="setSortSettings($event)"
  >
    <table mat-table #table *ngIf="dataSource?.data" [dataSource]="dataSource" multiTemplateDataRows>
      <ng-container [matColumnDef]="'keyword'">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span>{{ columnConfig['keyword'].name | translate }}</span>
        </th>
        <td
          mat-cell
          [ngClass]="seoData === expandedData && !hideDropdown ? 'hide-border' : ''"
          *matCellDef="let seoData"
        >
          <div class="table-cell keyword">
            @if (seoData.isFavorite) {
              <mat-icon>star</mat-icon>
            }

            {{ seoData.keyword.value }}
          </div>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="column" *ngFor="let column of statColumns">
        <th mat-header-cell [class]="columnConfig[column].class" *matHeaderCellDef mat-sort-header>
          <ng-container *ngIf="columnConfig[column].iconURL as iconURL">
            <img [src]="iconURL" />
          </ng-container>
          <span [innerHTML]="columnConfig[column].name | translate"></span>
        </th>
        <td
          [class]="columnConfig[column].class"
          mat-cell
          [ngClass]="seoData === expandedData && !hideDropdown ? 'hide-border' : ''"
          *matCellDef="let seoData"
        >
          <div class="table-cell">
            {{ seoData[column].value }}
            <ng-container *ngIf="columnConfig[column].showDelta">
              <ng-container *ngIf="columnConfig[column].deltaColumn as deltaColumn">
                <local-seo-delta
                  *ngIf="seoData[deltaColumn]?.rawValue > 0"
                  [value]="-1 * (seoData[column]?.rawValue - seoData[deltaColumn]?.rawValue)"
                ></local-seo-delta>
              </ng-container>
            </ng-container>
          </div>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="'empty'">
        <th mat-header-cell *matHeaderCellDef></th>
      </ng-container>

      <ng-container [matColumnDef]="'local'">
        <th mat-header-cell [attr.colspan]="2" [class]="columnConfig['local'].class" *matHeaderCellDef mat-sort-header>
          <ng-container *ngIf="columnConfig['local'].iconURL as iconURL">
            <img [src]="iconURL" />
          </ng-container>
          <div>{{ columnConfig['local'].name | translate }}</div>
        </th>
      </ng-container>

      <ng-container [matColumnDef]="'organic'">
        <th
          mat-header-cell
          [attr.colspan]="2"
          [class]="columnConfig['organic'].class"
          *matHeaderCellDef
          mat-sort-header
        >
          <ng-container *ngIf="columnConfig['organic'].iconURL as iconURL">
            <img [src]="iconURL" />
          </ng-container>
          <div>{{ columnConfig['organic'].name | translate }}</div>
        </th>
      </ng-container>

      <ng-container [matColumnDef]="'empty2'">
        <th class="divided" [attr.colspan]="2" mat-header-cell *matHeaderCellDef></th>
      </ng-container>

      <ng-container matColumnDef="expandIcon" sticky>
        <th mat-header-cell *matHeaderCellDef class="expand-icon-col"></th>
        <td
          mat-cell
          *matCellDef="let element"
          class="expand-icon-col"
          [ngClass]="element === expandedData && !hideDropdown ? 'hide-border' : ''"
        >
          <mat-icon *ngIf="!hideDropdown" [@rotateIcon]="element === expandedData ? 'up' : 'down'">
            expand_more
          </mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td
          mat-cell
          *matCellDef="let element"
          [attr.colspan]="columns.length"
          [ngClass]="element === expandedData && !hideDropdown ? '' : 'hide-border'"
        >
          <div
            *ngIf="!hideDropdown"
            class="sub-table-container"
            [@detailExpand]="element === expandedData ? 'expanded' : 'collapsed'"
          >
            <ng-container *ngIf="expandedData === element">
              <ng-container *ngIf="!editionUpgradeHidden; else settingsTab">
                <div class="tab-button-container">
                  <mat-button-toggle-group value="grid">
                    <mat-button-toggle (click)="onSelectActiveTab('grid')" value="grid" data-id="grid">
                      <mat-icon>grid_on</mat-icon>
                      {{ 'LOCAL_SEO.LOCAL_SEO.KEYWORD.EXPANDED_DROPDOWN.TAB.LOCAL_GRID' | translate }}
                    </mat-button-toggle>
                    <mat-button-toggle (click)="onSelectActiveTab('graph')" value="graph" data-id="graph">
                      <mat-icon>trending_up</mat-icon>
                      {{ 'LOCAL_SEO.LOCAL_SEO.KEYWORD.EXPANDED_DROPDOWN.TAB.TREND' | translate }}
                    </mat-button-toggle>
                    <mat-button-toggle
                      *ngIf="!disableEditingKeywords"
                      (click)="onSelectActiveTab('settings')"
                      value="settings"
                      data-id="settings"
                    >
                      <mat-icon>settings</mat-icon>
                      {{ 'LOCAL_SEO.LOCAL_SEO.KEYWORD.EXPANDED_DROPDOWN.TAB.SETTINGS' | translate }}
                    </mat-button-toggle>
                  </mat-button-toggle-group>
                </div>
                <ng-container *ngIf="activeTab === 'grid'">
                  <ng-container *ngIf="proActive; else blurredGrid">
                    <local-seo-grid
                      *ngIf="!expandedData?.inProgress; else keywordEmpty"
                      [accountGroupId]="agid"
                      [localSEOData]="expandedData"
                      [businessData]="location"
                      [zoomValue]="getZoomLevel(expandedData.searchRadius)"
                      [radiusSetting]="settings.localSearchRadius"
                    ></local-seo-grid>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="activeTab === 'graph'">
                  <ng-container *ngIf="proActive; else blurredGraph">
                    <local-seo-graph
                      *ngIf="!expandedData?.inProgress; else keywordEmpty"
                      [localSEOData]="expandedData"
                    ></local-seo-graph>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="activeTab === 'settings'">
                  <ng-container *ngTemplateOutlet="settingsTab"></ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-template #settingsTab>
              <div class="settings">
                <div class="settings-toggle">
                  <mat-slide-toggle
                    [checked]="expandedData.isFavorite"
                    (change)="updateFavoriteKeywords(expandedData.keyword.value, $event.checked)"
                  ></mat-slide-toggle>
                  <div>
                    <div class="settings-toggle-title">
                      {{ 'LOCAL_SEO.LOCAL_SEO.KEYWORD.EXPANDED_DROPDOWN.SETTINGS.FAVORITE_KEYWORD' | translate }}
                    </div>
                    <div class="settings-toggle-subtitle">
                      {{
                        'LOCAL_SEO.LOCAL_SEO.KEYWORD.EXPANDED_DROPDOWN.SETTINGS.FAVORITE_KEYWORD_SUBTITLE' | translate
                      }}
                    </div>
                  </div>
                </div>
                <div class="settings-toggle">
                  <mat-slide-toggle
                    [checked]="keywordStore?.syncingKeywords?.includes(expandedData.keyword.value)"
                    (change)="updateSyncingKeywords(expandedData.keyword.value, $event.checked)"
                  ></mat-slide-toggle>
                  <div>
                    <div class="settings-toggle-title">
                      {{ 'LOCAL_SEO.LOCAL_SEO.KEYWORD.EXPANDED_DROPDOWN.SETTINGS.SYNC_KEYWORD' | translate }}
                    </div>
                    <div class="settings-toggle-subtitle">
                      {{ 'LOCAL_SEO.LOCAL_SEO.KEYWORD.EXPANDED_DROPDOWN.SETTINGS.SYNC_KEYWORD_SUBTITLE' | translate }}
                    </div>
                  </div>
                </div>

                <button (click)="deleteKeyword.emit(expandedData.keyword.value)" mat-stroked-button>
                  {{ 'LOCAL_SEO.LOCAL_SEO.KEYWORD.EXPANDED_DROPDOWN.SETTINGS.DELETE_KEYWORD' | translate }}
                </button>
              </div>
            </ng-template>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="topColumns"></tr>
      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: columns"
        [class.expandable]="!hideDropdown"
        [class.example-expanded-row]="expandedData === row"
        (click)="onSelectActiveTab('grid'); expandedData = expandedData === row ? null : row"
      ></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expanded-detail-row"></tr>
    </table>
    <mat-paginator
      *ngIf="dataSource.data.length > 20"
      #paginator
      [pageSize]="20"
      [pageSizeOptions]="[10, 20, 50, 100]"
    ></mat-paginator>
  </div>
</ng-template>

<ng-template #loadingTable>
  <div
    matSort
    [matSortActive]="sortSettings.active"
    [matSortDirection]="sortSettings.direction"
    (matSortChange)="setSortSettings($event)"
  >
    <table mat-table #table [dataSource]="[{}]" multiTemplateDataRows>
      <ng-container [matColumnDef]="'keyword'">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <span>{{ columnConfig['keyword'].name | translate }}</span>
        </th>
      </ng-container>

      <ng-container [matColumnDef]="column" *ngFor="let column of statColumns">
        <th mat-header-cell [class]="columnConfig[column].class" *matHeaderCellDef mat-sort-header>
          <img *ngIf="columnConfig[column].iconURL" [src]="columnConfig[column].iconURL" />
          <span [innerHTML]="columnConfig[column].name | translate"></span>
        </th>
      </ng-container>

      <ng-container [matColumnDef]="'empty'">
        <th mat-header-cell *matHeaderCellDef></th>
      </ng-container>

      <ng-container [matColumnDef]="'local'">
        <th mat-header-cell [attr.colspan]="2" [class]="columnConfig['local'].class" *matHeaderCellDef mat-sort-header>
          <ng-container *ngIf="columnConfig['local'].iconURL as iconURL">
            <img [src]="iconURL" />
          </ng-container>
          <div>{{ columnConfig['local'].name | translate }}</div>
        </th>
      </ng-container>

      <ng-container [matColumnDef]="'organic'">
        <th
          mat-header-cell
          [attr.colspan]="2"
          [class]="columnConfig['organic'].class"
          *matHeaderCellDef
          mat-sort-header
        >
          <ng-container *ngIf="columnConfig['organic'].iconURL as iconURL">
            <img [src]="iconURL" />
          </ng-container>
          <div>{{ columnConfig['organic'].name | translate }}</div>
        </th>
      </ng-container>

      <ng-container [matColumnDef]="'empty2'">
        <th class="divided" [attr.colspan]="2" mat-header-cell *matHeaderCellDef></th>
      </ng-container>

      <ng-container matColumnDef="expandIcon" sticky>
        <th mat-header-cell *matHeaderCellDef class="expand-icon-col"></th>
        <td
          mat-cell
          *matCellDef="let element"
          class="expand-icon-col"
          [ngClass]="element === expandedData && !hideDropdown ? 'hide-border' : ''"
        >
          <mat-icon [@rotateIcon]="element === expandedData ? 'up' : 'down'">expand_more</mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td
          mat-cell
          *matCellDef="let element"
          [attr.colspan]="columns.length"
          [ngClass]="element === expandedData && !hideDropdown ? '' : 'hide-border'"
        >
          <glxy-loading-spinner></glxy-loading-spinner>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="topColumns"></tr>
      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expanded-detail-row"></tr>
    </table>
    <mat-paginator #paginator [pageSize]="20" [pageSizeOptions]="[10, 20, 50, 100]"></mat-paginator>
  </div>
</ng-template>

<ng-template #blurredGrid>
  <div class="blurred">
    <button (click)="upgradeButtonClicked.emit()" color="primary" class="blurred-grid-button" mat-raised-button>
      {{ 'LOCAL_SEO.LOCAL_SEO.UPGRADE_TO_VIEW' | translate }}
    </button>
    <img
      class="blurred-grid"
      src="https://vstatic-prod.apigateway.co/listing-builder-client/assets/images/blurred-grid.png"
      alt="seoGridBlurred"
    />
  </div>
</ng-template>

<ng-template #blurredGraph>
  <div class="blurred">
    <button (click)="upgradeButtonClicked.emit()" color="primary" class="blurred-graph-button" mat-raised-button>
      {{ 'LOCAL_SEO.LOCAL_SEO.UPGRADE_TO_VIEW' | translate }}
    </button>
    <img
      class="blurred-graph"
      src="https://vstatic-prod.apigateway.co/listing-builder-client/assets/images/blurred-seo-graph.png"
      alt="seoGraphBlurred"
    />
  </div>
</ng-template>

<ng-template #keywordEmpty>
  <glxy-empty-state data-testid="ls-inprogress-state" [size]="'small'" class="empty-state-container">
    <glxy-empty-state-hero>
      <mat-icon>pending</mat-icon>
    </glxy-empty-state-hero>
    <glxy-empty-state-title>
      {{ 'LOCAL_SEO.LOCAL_SEO.IN_PROGRESS_TITLE' | translate }}
    </glxy-empty-state-title>
    <p>{{ 'LOCAL_SEO.LOCAL_SEO.IN_PROGRESS_DESCRIPTION' | translate }}</p>
  </glxy-empty-state>
</ng-template>
